import { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { push as changeLocation } from 'connected-react-router';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Classes, Drawer, Card, Button } from '@blueprintjs/core';

import { getRequest } from '@f/services/batch-search/batch-search.actions';
import BatchSearchStatusTag from '@f/components/shared/batch-search-status-tag/BatchSearchStatusTag';

import { BatchSearchDetailsExport } from '../../components/BatchSearchDetailsExport';

import cls from './ItemDrawerPage.module.css';

class ItemDrawer extends PureComponent {
  static propTypes = {
    id: PropTypes.string,
    request: PropTypes.object,
    isGetting: PropTypes.bool,
    gettingError: PropTypes.object,
    changeLocation: PropTypes.func,
    getRequest: PropTypes.func,
  };

  state = {
    isOpen: false,
  };

  componentDidMount() {
    this.onUpdateDetails();
  }

  componentDidUpdate(prevProps) {
    const { request, gettingError } = this.props;
    const { request: prevRequestDetails, gettingError: prevGettingDetailsError } = prevProps;

    const haveRequestDetailsChanged = request && request !== prevRequestDetails;
    const hasGettingDetailsErrorChanged = gettingError && gettingError !== prevGettingDetailsError;

    if (haveRequestDetailsChanged || hasGettingDetailsErrorChanged) {
      this.onOpen();
    }
  }

  componentWillUnmount() {
    this.onClose();
  }

  onUpdateDetails = () => {
    const { id } = this.props;
    this.props.getRequest(id, {
      findAny: true,
    });
  };

  onOpen = () => {
    this.setState({ isOpen: true });
  };

  onClose = () => {
    this.setState({ isOpen: false });
  };

  onClosed = () => {
    this.props.changeLocation('/dashboard/administration/batch-search-requests');
  };

  render() {
    const { request, isGetting, gettingError } = this.props;
    const { isOpen } = this.state;

    if (!request && !gettingError) {
      return null;
    }

    const hasBeenRemoved = request.isRemoved;

    return (
      <Drawer
        isOpen={isOpen}
        canEscapeKeyClose
        canOutsideClickClose
        isCloseButtonShown
        title={
          <div className={cls.titleContainer}>
            <span>Batch request details</span>
            <Button minimal disabled={isGetting} loading={isGetting} icon="refresh" onClick={this.onUpdateDetails} />
          </div>
        }
        size={400}
        onClose={this.onClose}
        onClosed={this.onClosed}
      >
        {request.status && (
          <div className={cx(Classes.DRAWER_BODY, cls.drawer)}>
            <div className={cls.record}>
              <small className={cls.primaryLabel}>STATUS</small>
              <BatchSearchStatusTag large status={request.status} removed={hasBeenRemoved} />
            </div>

            {!hasBeenRemoved && !gettingError && (
              <div className={cls.record}>
                <small className={cls.primaryLabel}>JOBS</small>
                <div className={cls.valueCardContainer}>
                  <Card className={cls.valueCard}>
                    <p className={cls.value}>{request.status.queued}</p>
                    <small className={cls.secondaryLabel}>queued</small>
                  </Card>

                  <Card className={cls.valueCard}>
                    <p className={cls.value}>{request.status.running}</p>
                    <small className={cls.secondaryLabel}>running</small>
                  </Card>

                  <Card className={cls.valueCard}>
                    <p className={cls.value}>{request.status.finished}</p>
                    <small className={cls.secondaryLabel}>finished</small>
                  </Card>

                  {request.status.error > 0 && (
                    <Card className={cls.valueCard}>
                      <p className={cls.value}>{request.status.error}</p>
                      <small className={cls.secondaryLabel}>error</small>
                    </Card>
                  )}
                </div>
              </div>
            )}
            <BatchSearchDetailsExport batchId={request.id} />
          </div>
        )}
      </Drawer>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const { requestId: id } = ownProps.match.params;

  const requestState = state.batchSearch.request;
  const request = requestState.data[id];
  const isGetting = requestState.get.processing > 0;
  const gettingError = requestState.get.error;

  return {
    id,
    request,
    isGetting,
    gettingError,
  };
}

export default withRouter(connect(mapStateToProps, { changeLocation, getRequest })(ItemDrawer));
